<template>
  <div v-if="!isLoading" class="detail-info">
    <section>
      <div class="detail-info-top-area">
        <div class="desc-box">
          <p class="title">{{ title }}</p>
          <p class="synopsis" v-html="synopsis"></p>
        </div>
      </div>

      <div class="detail-info-bottom-area">
        <div class="text-area">
          <div class="metadata-area">
            <table>
              <caption>메타데이터표</caption>
              <colgroup>
                <col style="width: 48px;">
                <col>
              </colgroup>
              <tbody>
              <tr v-if="originTitle !== ''">
                <th>원제</th>
                <td>{{ originTitle }}</td>
              </tr>
              <tr>
                <th>개요</th>
                <td>{{ summary }}</td>
              </tr>
              <tr v-if="tagList.length > 0">
                <th>장르</th>
                <td>
                  <span v-for="(tag, index) in tagList" :key="tag.value + index">
                    #{{tag.text}}{{tagList.length -1 !== index ? ',' : '' }}
                  </span>
                </td>
              </tr>
              <tr v-if="actorList.length > 0">
                <th>출연</th>
                <td>
                  <span v-for="(actor, index) in actorList" :key="'actor' + index">
                    {{actor.value}}{{actorList.length - 1 !== index ? ',' : ''}}
                  </span>
                </td>
              </tr>
              <tr v-if="directorList.length > 0">
                <th>감독</th>
                <td>
                  <span v-for="(director, index) in directorList" :key="'director' + index">
                    {{director.value}}{{directorList.length - 1 !== index ? ',' : ''}}
                  </span>
                </td>
              </tr>
              <tr v-if="deliverationInfo !== ''">
                <th>정보</th>
                <td>{{ deliverationInfo }}</td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import { get } from 'lodash'
import { MovieInfoService } from '@/common/api/api.service'
import { clickTag, searchByKeyword } from '@/common/util/player.util'
export default {
  name: 'ApolloMovieDetailInfo',
  components: {
  },
  data () {
    return {
      isOpenDetailPopup: false,
      contentInfo: {},
      tagList: [],
      isLoading: true
    }
  },
  computed: {
    summary () {
      const { cpname = '', country = '', releasedate = '' } = this.contentInfo
      const year = releasedate.substring(0, 4)
      const yearInfo = year.length > 0 ? `${year}년` : ''
      return [cpname, country, yearInfo].filter(infoText => infoText !== '').join(', ')
    },
    title () {
      return get(this.contentInfo, 'title', '')
    },
    synopsis () {
      return get(this.contentInfo, 'synopsis', '')
    },
    originTitle () {
      return get(this.contentInfo, 'origintitle', '')
    },
    actorList () {
      return get(this.contentInfo, 'actors.list', [])
    },
    directorList () {
      return get(this.contentInfo, 'directors.list', [])
    },
    deliverationInfo () {
      return get(this.contentInfo, 'deliverationinfo', '')
    }
  },
  methods: {
    setData () {
      this.isLoading = true
      const movieID = get(this.$route, 'query.movieid', '')
      MovieInfoService.getMovieMetaInfo({ movieID }, (error) => {
        alert(error.response.data.resultmessage)
        this.routerBack()
      }).then(({ data }) => {
        this.contentInfo = data
        console.log(this.contentInfo)
        const tagCount = get(this.contentInfo, ['tags', 'count'], '')
        if (tagCount === '' || tagCount === '0') {
          this.isLoading = false
          return []
        }
        let tagList = get(this.contentInfo, ['tags', 'list'], []).map((tag) => {
          if (typeof tag === 'string') {
            return {
              text: tag,
              value: tag,
              taggroup: 'tag'
            }
          } else {
            if (tag.taggroup === undefined) {
              tag.taggroup = 'tag'
            }
            return tag
          }
        })
        this.tagList = tagList.filter((tag) => { return tag.text !== '' })
        this.isLoading = false
      })
    },
    closePopup () {
      this.$router.back()
    },
    searchByKeywordFn (keyword) {
      searchByKeyword({ keyword, isDetailInfo: true })
    },
    clickTagFn (tag) {
      clickTag({ currentSection: 'movie', tag, contentInfo: this.contentInfo })
    }
  },
  created () {
    this.setData()
  }
}
</script>
